var EHDI = EHDI || Object.create(null);
var CKM = CKM || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

CKM.Cake  = function() 
{
    EHDI.aka.Container.call(this);

    var SHAKE_TIME = 200;
    var MATCH_WORTH = 5;
    var JELLY_BONUS = 5;
    var POPSICLE_BONUS = 5;

    var _me = this;
    var _type;
    var _visual, _glowVisual;
    var _isShaking, _shakeTimer;
    var _multiplierBonus;
    var _scoreWorth;

    var  _init = function(type)
    {
        _initProps(type);
        _initGraphics();
        _dim();
    }
    this.init = _init.bind(this);

    var _dispose = function()
    {
        _killGraphics();
        _killProps();

        POOLS.cakePool.returnToPool(_me);
    }
    this.dispose = _dispose.bind(this);

    //Initialization
    var _initProps = function(type)
    {
        // 8 types + jelly + 1 brownie + 1 choco bar
        // _type = Math.floor(Math.random() * 11);
        if(typeof type !== 'number')
            _type = Math.floor(Math.random() * EHDI.constants.cakeVariationCount);
        else
            _type = type;

        _isShaking= false;
        _shakeTimer =0;
    }

    var _initGraphics = function()
    {        
        _glowVisual = new EHDI.aka.Sprite(EHDI.Assets.images["fx_glow_selected"]);
        _glowVisual.x = -5;
        _glowVisual.y = -5;
        // _me.addChild(_glowVisual);

        _updateTexture();

        _me.addChild(_visual);
        _me.addChild(_glowVisual);
    }

    var _updateTexture = function()
    {
        var assetId = "";
        if(_type < 0)
        {  
            _scoreWorth = 0;
            _multiplierBonus = 0;
            _visual.texture = null;
            return;
        }

        if(_type < 20)
        {
            var cakeId = _type +1;
            assetId = "cake_"+ (cakeId.toString().padStart(2,"0"));

            _scoreWorth = MATCH_WORTH;
            _multiplierBonus = 1;
        }
        else if(_type < 23)
        {
            var popsicleId = _type -19;
            assetId = "popsicle_"+ (popsicleId.toString().padStart(2,"0"));

            _scoreWorth = 0;
            _multiplierBonus = POPSICLE_BONUS;
        }
        else
        {
            var jellyId = _type - 22;
            assetId = "donut_"+ (jellyId.toString().padStart(2,"0"));

            _scoreWorth = 0;
            _multiplierBonus = JELLY_BONUS;

        }

        if(_visual)
            _visual.texture = EHDI.Assets.images[assetId];
        else
            _visual = new EHDI.aka.Sprite(EHDI.Assets.images[assetId]);

    }

    var _updateType = function(type)
    {
        if(typeof type !== 'number')
            return false;

        _type = type;
        _updateTexture();
        return true;
    }

    //Disposal
    var _killGraphics = function()
    {
        _me.removeChildren();
        
        _visual.removeChildren();
        _visual = null;
        _glowVisual.removeChildren();
        _glowVisual = null;
    }
    var _killProps = function()
    {
        _isShaking = false;
        _type =null;
    }

    var _update =  function(delta)
    {
        if(_isShaking)
        {
            _shakeTimer -= delta;
            _visual.x = -5 + (Math.random() *10);

            if(_shakeTimer <= 0)
            {
                _isShaking = false;
                _visual.x =0;
            }
        }
    }


    var _glow = function()
    {
        _glowVisual.visible =  true;
    }

    var _dim = function()
    {
        _glowVisual.visible =  false;
    }

    var _shake = function()
    {
        _shakeTimer = SHAKE_TIME;
        _isShaking = true;
    }

    this.update = _update.bind(this);
    this.glow = _glow.bind(this);
    this.dim = _dim.bind(this);
    this.shake = _shake.bind(this);
    this.updateType = _updateType.bind(this);



    Object.defineProperties( _me, {
        "type":{
            get: function() {return _type;},
            enumerable: true

        },       
        "worth":{
            get: function() {return _scoreWorth;},
            enumerable: true
        },   
        "multiplier":{
            get: function() {return _multiplierBonus;},
            enumerable: true
        },


        // "isCaged": {
        //     get: function () { return _isCaged; },
        //     set: function ( p_value ) { if ( _isCaged !== p_value  ) _isCaged = p_value; },
        //     enumerable: true
        // }
    });

    return _me;
}
CKM.Cake.prototype = Object.create(EHDI.aka.Container.prototype);


POOLS.cakePool = new Pool(CKM.Cake, 300); 